var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionPageHero',{attrs:{"variant":"artworks","title-lead":_vm.$i18n.locale === 'en' ? 'Artwork' : 'ผลงาน',"title-highlight":_vm.$i18n.locale === 'en' ? 'Gallery' : 'ศิลปะ'}})}
var staticRenderFns = []

export { render, staticRenderFns }